import { useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useState } from 'react'
import Select, { OnChangeValue } from 'react-select'

import CloseArrow from '../../../images/close.svg'
import Invite from '../../../models/Invite'
import { ApiService } from '../../../services'
import { CityType } from '../../../types'
import InlineSpinner from '../../common/InlineSpinner'
import ModalSocial from './ModalSocial'

type Props = {
  settings: { utmContent: string; invite: Invite; cities: CityType[] }
  onClose: () => void
}

type SelectOption = {
  value: string
  label: string
}

const SelectCityDialog: React.FC<Props> = ({ settings, onClose }) => {
  const [selectedCityName, setSelectedCityName] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)

  const { t } = useTranslation()

  const onCityChangeHandler = (option: OnChangeValue<SelectOption, false>) => {
    if (option !== null) {
      setSelectedCityName(option?.value)
      ApiService.updateInvite({ id: settings.invite.id, city_name: option?.value })
    }
  }

  const onClickHandler = () => {
    if (!selectedCityName) return
    setLoading(true)
    const url = settings.invite.getRedirectUrl(settings.utmContent)

    window.location.href = url
  }

  const options: Array<SelectOption> = settings.cities.map(
    (c: CityType) =>
      ({
        value: c.name,
        label: c.name,
      } as SelectOption),
  )

  return (
    <>
      <button className="modal__close" onClick={onClose}>
        <img src={CloseArrow} />
      </button>
      <div className="modal__title">{t('Choose where to lunch with us!')}</div>
      <div className="modal__content">
        <div className="custom-select__wrapper">
          <Select
            classNamePrefix="custom-select"
            placeholder="Select a city..."
            isSearchable={false}
            onChange={onCityChangeHandler}
            options={options}
          />
        </div>
        <button onClick={onClickHandler} className="modal__action red-cta">
          {loading ? <InlineSpinner /> : t('Browse restaurants')}
        </button>
      </div>
      <div className="modal__description">{t('Don’t see your city? Follow us to see when we launch near you!')}</div>
      <ModalSocial />
    </>
  )
}

export default SelectCityDialog
